import { Theme as ITheme } from '@material-ui/core';

export const VideoTileStyles = (theme: ITheme) => ({
    container: {
        position: 'relative' as 'relative',
        borderRadius: theme.spacing(1),
    },
    tile: {
        display: 'flex',
        flexDirection: 'column' as 'column',
    },
    thumbnail: {
        width: '100%',
        overflow: 'hidden',
        borderRadius: theme.spacing(1),
        height: theme.spacing(25.875),
        transition: 'height 0.5s ease-out',
        '&.extended': {
            height: theme.spacing(29.5),
        },
        '& > span': {
            display: 'none',
            '&.loading': {
                height: '-webkit-fill-available',
                display: 'block',
            },
        },
        '& > div': {
            width: '100%',
            height: '100%',
            display: 'block',
            cursor: 'pointer',
            '&.loading': {
                display: 'none',
            },
            '& > video': {
                height: '100%',
                objectFit: 'initial',
            },
        },
    },
    info: {
        display: 'flex',
        flexDirection: 'column' as 'column',
        color: '#b8b8b8',
    },
    duration: {
        position: 'absolute' as 'absolute',
        borderRadius: '4px',
        marginTop: '-30px',
        marginLeft: '86%',
        padding: '1px 4px',
        backgroundColor: 'rgba(18, 18, 23, .7)',
        '& > span': {
            marginLeft: theme.spacing(0.5),
        },
    },
    recent: {
        marginLeft: 'auto',
        fontSize: '0.8em',
        fontWeight: 'bold' as 'bold',
        textTransform: 'uppercase' as 'uppercase',
        color: theme.palette.secondary.main,
    },
    title: {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap' as 'nowrap',
        padding: '8px 0 4px',
        fontWeight: 500,
        fontSize: 16,
        color: 'white',
    },
    subtitle: {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        minHeight: theme.spacing(2.5),
        maxHeight: theme.spacing(2.5),
        whiteSpace: 'nowrap' as 'nowrap',
        fontWeight: 400,
        fontSize: 16,
        color: 'rgba(250, 250, 250, 0.5)',
    },
    actions: {
        marginTop: 'auto',
        display: 'flex',
        justifyContent: 'start',
        marginLeft: '-8px',
        gap: 8,
        padding: '8px 0 0',
    },
    action: {
        borderRadius: theme.spacing(1),
        padding: 0,
        width: 30,
        height: 30,
        // backgroundColor: 'red',
        '&:hover': {
            backgroundColor: 'rgba(255, 255, 255, 0.2)',
        },
    },
    telestrate: {
        padding: theme.spacing(1),
        margin: theme.spacing(0.5),
        color: theme.palette.primary.main,
        marginLeft: 'auto',
        textTransform: 'capitalize' as 'capitalize',
        borderRadius: theme.spacing(1),
    },
});
